import React, { useState, useEffect } from "react";
import {
  Container,
  Row,
  Col,
  Form,
  Button,
  Card,
  Alert,
  Spinner,
} from "react-bootstrap";
import { Link, useNavigate, useLocation } from "react-router-dom";
import { useAuth } from "../../context/AuthContext";
import colors from "../../constants/colors";

const LoginPage = () => {
  const [formData, setFormData] = useState({ email: "", password: "" });
  const [validated, setValidated] = useState(false);
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const { user, login } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();

  // Redirect if user is already logged in
  useEffect(() => {
    if (user) {
      navigate(location.state?.from || "/");
    }
  }, [user, navigate, location.state]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const form = e.currentTarget;

    if (!form.checkValidity()) {
      e.stopPropagation();
      setValidated(true);
      return;
    }

    setLoading(true);
    setError("");

    try {
      await login(formData);

      setTimeout(() => {
        navigate("/");
      }, 3000);
    } catch (err) {
      setError(
        err.response?.data?.message ||
          "Credenciais inválidas. Por favor tente novamente."
      );
      console.error("Login error:", err);
    } finally {
      setLoading(false);
    }
  };

  return (
    <Container className="py-5" style={{ backgroundColor: colors.background }}>
      <Row className="justify-content-center">
        <Col md={6} lg={5}>
          <Card className="shadow" style={{ borderColor: colors.secondary }}>
            <Card.Body className="p-4">
              <h2 className="text-center mb-4" style={{ color: colors.dark }}>
                Iniciar Sessão
              </h2>

              {error && (
                <Alert variant="danger" style={{ color: colors.danger }}>
                  {error}
                </Alert>
              )}

              <Form noValidate validated={validated} onSubmit={handleSubmit}>
                <Form.Group className="mb-3" controlId="formEmail">
                  <Form.Label style={{ color: colors.dark }}>Email</Form.Label>
                  <Form.Control
                    type="email"
                    name="email"
                    value={formData.email}
                    onChange={handleChange}
                    required
                    placeholder="O teu email"
                    disabled={loading}
                    autoFocus
                    style={{ borderColor: colors.secondary }}
                  />
                  <Form.Control.Feedback type="invalid">
                    Por favor insira um email válido.
                  </Form.Control.Feedback>
                </Form.Group>

                <Form.Group className="mb-3" controlId="formPassword">
                  <Form.Label style={{ color: colors.dark }}>
                    Password
                  </Form.Label>
                  <Form.Control
                    type="password"
                    name="password"
                    value={formData.password}
                    onChange={handleChange}
                    required
                    placeholder="A tua senha"
                    disabled={loading}
                    style={{ borderColor: colors.secondary }}
                    autoComplete="current-password"
                  />
                  <Form.Control.Feedback type="invalid">
                    Por favor insere a tua senha.
                  </Form.Control.Feedback>
                </Form.Group>

                <Form.Group className="mb-4" controlId="formRememberMe">
                  <Form.Check
                    type="checkbox"
                    label="Lembrar-me"
                    disabled={loading}
                    style={{ color: colors.dark }}
                  />
                </Form.Group>

                <div className="d-grid gap-2">
                  <Button
                    type="submit"
                    size="lg"
                    disabled={loading}
                    style={{
                      backgroundColor: colors.secondary,
                      borderColor: colors.secondary,
                      color: colors.light,
                    }}
                  >
                    {loading ? (
                      <>
                        <Spinner
                          as="span"
                          animation="border"
                          size="sm"
                          role="status"
                          aria-hidden="true"
                          className="me-2"
                          style={{ borderColor: colors.secondary }}
                        />  
                        A processar...
                      </>
                    ) : (
                      "Iniciar Sessão"
                    )}
                  </Button>
                </div>
              </Form>

              <div className="mt-4 text-center">
                <p className="mb-2" style={{ color: colors.textGray }}>
                  Não tem uma conta?{" "}
                  <Link to="/register" style={{ color: colors.secondary }}>
                    Registar
                  </Link>
                </p>
                <p>
                  <Link to="/recuperar-senha" style={{ color: colors.secondary }}>
                    Esqueceu-se da tua senha?
                  </Link>
                </p>
              </div>
            </Card.Body>
          </Card>
        </Col>
      </Row>
    </Container>
  );
};

export default LoginPage;
